import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectAdjustmentSettings } from '../orderSelectors.ts';
import { createPriceSelector } from '../utils/createPriceSelector.ts';
import { selectFullBathsAdj } from './selectFullBathsAdj.ts';
import { selectHalfBathsAdj } from './selectHalfBathsAdj.ts';
import { applyRoundingAndThresholds } from './utils/applyRoundingAndThresholds.ts';
import { getColorFromAdjustment } from './utils/getColorFromAdjustment.ts';
import { getStringValueFromAdjustment } from './utils/getStringValueFromAdjustment.ts';

const calculateBathsAdj = (fullBathsAdj?: AloftPrice, halfBathsAdj?: AloftPrice) => {
  return [fullBathsAdj || AloftPrice.zero, halfBathsAdj || AloftPrice.zero].reduce(
    (acc: AloftPrice, curr) => acc.add(curr),
    AloftPrice.zero,
  );
};

const selectBathsAdj = createPriceSelector(
  [selectFullBathsAdj, selectHalfBathsAdj],
  calculateBathsAdj,
);

const selectAppliedBathsAdj = createPriceSelector(
  [selectBathsAdj, selectAdjustmentSettings],
  (adj, adjSettings) => {
    if (isUndefined(adj)) {
      return undefined;
    }

    return applyRoundingAndThresholds(adj, 'bathAboveGrade', adjSettings);
  },
);

export const selectAppliedBathsAdjDisplay = createSelector([selectAppliedBathsAdj], (adj) => {
  if (isUndefined(adj)) {
    return undefined;
  }

  return {
    value: getStringValueFromAdjustment(adj),
    color: getColorFromAdjustment(adj),
  };
});
